// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"3c901b7b","260":"8a66e542","453":"71b820a6"}[chunkId] + ".chunk.js";
};